module.exports = __webpack_public_path__ + "static/media/ic_kran_gray.f584e41e.png";